import styled from "styled-components"

export const Bar = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 40;
  padding: 0.75rem 20px calc(0.75rem + env(safe-area-inset-bottom, 0px));
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: saturate(180%) blur(8px);
  border-top: 1px solid var(--line);
  transform: translateY(${({ $visible }) => ($visible ? "0" : "110%")});
  visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
  transition: transform 0.25s ease, visibility 0.25s;
  a {
    width: 100%;
  }
  @media (min-width: 992px) {
    display: none;
  }
`
